module.exports = __webpack_public_path__ + "media/images/new_home/2-anthony-edwards-9eb29bbe7aad843eaf11b5ed889cde14.png";